import { TableV2 } from '@anytag/shared-atoms';
import { TableData } from '@anytag/shared-types';
import { useTableMaxHeight } from '@anytag/shared-hooks';
import { YoutubeCmsEstimateAsset } from '@anytag/graphql';
import { useYoutubeCMSChannelsAssetsTable } from './hooks';

export type YoutubeCMSChannelsAssetsListProps = TableData<YoutubeCmsEstimateAsset>;

export const YoutubeCMSChannelsAssetsList = ({ loading, data = [] }: YoutubeCMSChannelsAssetsListProps) => {
  const { offsetRef, defaultTableMaxHeight } = useTableMaxHeight();
  const { columns } = useYoutubeCMSChannelsAssetsTable();

  return (
    <TableV2
      data={data}
      ref={offsetRef}
      loading={loading}
      columns={columns}
      rowHeight="64px"
      maxHeight={defaultTableMaxHeight}
      noTopBorderRadius
      stickyHeader
    />
  );
};
